export const POINTS_MAIL_LIST = 'POINTS_MAIL_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/store/mutations-types.js